/**
 * PVM/GPS "WERTENTWICKLUNG NACH PERIODEN" — fixed columns + row label.
 * Target: Zeitraum | 1 Monat | YTD | 1 Jahr | 3 Jahre | 5 Jahre | seit Auflage
 * First data cell: Rendite (never ETF / Fonds from SHV clones).
 *
 * Always uses live Axion `isDynamic` cells — never keeps static percent strings
 * that freeze across regenerations (1M/YTD/1J/seit Auflage bug).
 */

export const PVM_PERIOD_LABELS = [
  'Zeitraum',
  '1 Monat',
  'YTD',
  '1 Jahr',
  '3 Jahre',
  '5 Jahre',
  'seit Auflage',
] as const;

const PERIOD_DB_FIELD: Record<string, string> = {
  '1 Monat': 'm1',
  YTD: 'laufendesjahr',
  '1 Jahr': 'j1',
  '3 Jahre': 'j3',
  '5 Jahre': 'j5',
  'seit Auflage': 'seitauflage',
};

function makeDynamicPercentCell(field: string) {
  return {
    isDynamic: true,
    fields: [
      {
        type: 'table',
        table: 'cixon_wertentwicklung_vergangen',
        field,
        valueType: 'percentage',
      },
    ],
  };
}

export function normalizePvmPeriodPerformance(_raw?: unknown): {
  labels: string[];
  values: any[][];
  columns: Array<{ type: string }>;
} {
  const outLabels = [...PVM_PERIOD_LABELS];
  const outRow: any[] = ['Rendite'];
  const outColumns: Array<{ type: string }> = [{ type: 'text' }];

  for (let i = 1; i < outLabels.length; i++) {
    const label = outLabels[i];
    outRow.push(makeDynamicPercentCell(PERIOD_DB_FIELD[label]));
    outColumns.push({ type: 'text' });
  }

  return {
    labels: outLabels,
    values: [outRow],
    columns: outColumns,
  };
}
